// ─── src/components/Footer.jsx ────────────────────────────────────────────
function Footer() {
  return (
    <footer id="footer" className="footer">
      <div className="container">
        <div className="row-base row">
          <div className="col-base text-left-md col-md-4">
            <a href="/" className="brand" aria-label="Xin Chuan home">
              <img
                src="img/img-icon/logo_xinchuan.svg"
                alt="Xin Chuan logo"
                style={{ height: 80, maxWidth: "100%" }}
              />
            </a>
          </div>

          {/* centre column left blank on purpose */}
          <div className="text-center-md col-base col-md-4" />

          <div className="text-right-md col-base col-md-4">
            © XIN CHUAN 2025. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
